import React from "react";
import Button from "react-bootstrap/Button";
import config from "../../../config";
import { useSelector } from "react-redux";
import { isRPlusMembershipActive } from "../../common/utils";

const PersonalizedRPlusSellerReminder = () => {
    const { user_profile } = useSelector(state => ({
        user_profile: state.myAccountReducer.user_profile,
    }));
    const activeMembership = user_profile && isRPlusMembershipActive(user_profile);

    if (!user_profile || !user_profile.is_r_plus_pending || activeMembership) {
        return null;
    }

    return (
        <div className="homepage-personalization__returning-user-cart">
            <div className="homepage-personalization__rplus-seller-flow">
                <div className="homepage-personalization__rplus-seller-flow-subtitle">
                    Last Chance to Earn Up to 5% More
                </div>
                <div className="homepage-personalization__rplus-seller-flow-text">
                    <p className="homepage-personalization__rplus-seller-flow-paragraph">
                        If you don’t sign up for Rebag⁺ before we receive your items, you’ll miss out on exclusive benefits including up to 5% higher payouts with Consign and Buyout.
                    </p>
                </div>
                <Button
                    className="rbg-btn-dark homepage-personalization__rplus-seller-flow-button"
                    variant="clean"
                    href={`${config.host_rebag}/joinmembership?source=seller_reminder`}
                >
                    Join Rebag⁺
                </Button>
            </div>
        </div>
    )
}

export default PersonalizedRPlusSellerReminder;